module.exports = __webpack_public_path__ + "img/schema 2.7e598aaa.svg";